// lib
import "react-app-polyfill/stable"; // among other for Edge compatibility
import "whatwg-fetch"; // IE 11
import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import * as serviceWorker from "serviceWorker";
// css
import CssBaseline from "@material-ui/core/CssBaseline";
import "styles/index.scss";
// src
import Root from "containers/Root";
import store from "store";
import { msalInstance } from "services/ms365";
import { fetchBackToken } from "actions/user/thunks";
import { APP_VERSION } from "config/constants";
import "i18n/proxy";

console.info(`[plannings] version: ${APP_VERSION}`);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#786386", // for instance main buttons background color
    },
    secondary: {
      main: "#55aa98", // for instance main buttons color
    },
    background: {
      default: "#ffffff",
    },
    text: {
      primary: "#2a313a",
    },
  },
});

const renderApp = () =>
  render(
    <Provider store={store}>
      <BrowserRouter basename="/plannings">
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Root />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>,
    document.getElementById("app-container"),
  );

msalInstance
  .handleRedirectPromise()
  .then((response) => {
    if (response) store.dispatch(fetchBackToken(response.idToken));
  })
  .catch((error) => console.error(error))
  .finally(renderApp);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
